/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assign_Driver_LabelInputs */

const vi_assign_driver_label = /** @type {(inputs: Assign_Driver_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài xế`)
};

/**

* @param {Assign_Driver_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const assign_driver_label = /** @type {((inputs?: Assign_Driver_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assign_Driver_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_assign_driver_label(inputs)
});